module.exports = __webpack_public_path__ + "img/logo.9f484b87.png";